import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Identifiable, OrganizationalUnit } from "@planzone/dto";
import { useEditResource } from "@planzone/view-models";
import { SelectList } from "@common/selectList";
import { OrganizationalUnitsHierarchy } from "@common/organizationalUnitsHierarchy";
import { ArrowIcon } from "../roleSelection/arrowIcon";
import { Props } from "./types";
import styles from "./styles.scss";

function OrganizationalUnitSelection(props: Props) {
  const { t } = useTranslation();
  const { editResource } = useEditResource(props.resource);

  const selectOrganizationalUnit = (
    organizationalUnit: Identifiable<OrganizationalUnit> | null,
  ) =>
    editResource({
      resource: props.resource,
      nextResource: { ...props.resource, organizationalUnit },
    });

  return props.readOnly ? (
    <div
      className={classNames(styles.input, styles.readOnly, {
        [styles.compact]: props.isCompact,
      })}
    >
      {props.resource.organizationalUnit ? (
        <p>{props.resource.organizationalUnit.name}</p>
      ) : (
        <p className={styles.textHidden}>e</p>
      )}
    </div>
  ) : (
    <SelectList
      rootClassName={styles.organizationalUnitSelection}
      listClassName={styles.listRoot}
    >
      {({ isOpen, select }) => ({
        input: (
          <div
            className={classNames(styles.input, {
              [styles.openedInput]: isOpen,
              [styles.compact]: props.isCompact,
            })}
          >
            {props.resource.organizationalUnit ? (
              <p>{props.resource.organizationalUnit.name}</p>
            ) : (
              <p className={styles.placeholder}>
                {t("planzoneMembersPage.organizationalUnit.none")}
              </p>
            )}
            {isOpen ? (
              <ArrowIcon className={styles.iconOpen} />
            ) : (
              <ArrowIcon className={styles.iconClose} />
            )}
          </div>
        ),
        list: (
          <div className={styles.list}>
            <OrganizationalUnitsHierarchy
              isSelected={({ uuid }) =>
                props.resource.organizationalUnit?.uuid === uuid
              }
              select={(organizationalUnit) =>
                select(selectOrganizationalUnit(organizationalUnit))
              }
            >
              <div
                className={classNames(styles.none, {
                  [styles.selected]: !props.resource.organizationalUnit,
                })}
                onClick={() => select(selectOrganizationalUnit(null))}
              >
                {t("planzoneMembersPage.organizationalUnit.none")}
              </div>
            </OrganizationalUnitsHierarchy>
          </div>
        ),
      })}
    </SelectList>
  );
}

export { OrganizationalUnitSelection };
